import { render, staticRenderFns } from "./OutlineContainer.vue?vue&type=template&id=8808b8d6&scoped=true"
var script = {}
import style0 from "./OutlineContainer.vue?vue&type=style&index=0&id=8808b8d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8808b8d6",
  null
  
)

export default component.exports